module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  if(widget.controls.length) { 
    ; __append("\n<div class=\"form__filter collapsed\">\n    <i on-click=\"onFilterToggleClick\" class=\"toggle icon-filter\"></i>\n    <!--<i on-click=\"onFilterToggleClick\" class=\"toggle icon-filter2\"></i>-->\n    <div name=\"filter-content\">\n        ")
    ;  for (var i = 0; i < widget.controls.length; i++) { 
    ; __append("\n            ")
    ;  var row = widget.controls[i]; 
    ; __append("\n            ")
    ; __append( UI.Template.render(widget.templateRow, { widget: widget, controls: row }) )
    ; __append("\n        ")
    ;  } 
    ; __append("\n    </div>\n    <div class=\"table w100\">\n        <div>\n            <div>\n                ")
    ;  for (var i = 0; i < widget.actions.length; i++) { 
    ; __append("\n                    ")
    ;  var action = widget.actions[i]; 
    ; __append("\n                    <button on-click=\"")
    ; __append(escapeFn(action.event ))
    ; __append("\">")
    ; __append(escapeFn(action.title ))
    ; __append("</button>\n                ")
    ;  } 
    ; __append("\n            </div>\n        </div>\n    </div>\n</div>\n")
    ;  } 
    ; __append("\n")
  }
  return __output.join("");

}